// Hook to fetch /salesDocs

/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useState } from 'react';

export const useFetchSalesDocs = () => {
    const [files, setFiles] = useState([]);

    const [loading, setLoading] = useState(true);
    // calling refetchSalesDocs will force a rerender on the hook
    const [shouldRefetchSalesDocs, setShouldRefetchSalesDocs] = useState({});

    const refetchSalesDocs = () => setShouldRefetchSalesDocs({});

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/salesDocs', {
                    cancelToken: source.token
                });
                if (Response.hasData(response, { noId: true })) {
                    setFiles(Response.getData(response, { noId: true }));
                } else {
                    debug.e('No sales docs found.');
                }
            } catch (error) {
                debug.e('Error getting sales docs.', error);
            }
            setLoading(false);
        };

        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [shouldRefetchSalesDocs]);

    return {
        files,
        loading,
        // returning the refetchSalesDocs function so we can call it as needed.
        refetchSalesDocs
    };
};
